import { render } from "./LoadingImageWidget.vue?vue&type=template&id=13b2bb62&ts=true"
import script from "./LoadingImageWidget.vue?vue&type=script&lang=ts"
export * from "./LoadingImageWidget.vue?vue&type=script&lang=ts"

import "./LoadingImageWidget.vue?vue&type=style&index=0&id=13b2bb62&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__